import { createAction } from '@reduxjs/toolkit';
import { APPLY_SINGLE_CHOISE_FILTERS } from './constants';
import type { ChangeFilterPayload } from './types';

export const applySingleChoiseFilters = createAction<ChangeFilterPayload>(
  APPLY_SINGLE_CHOISE_FILTERS,
);
